import { api } from 'app/utils/api/helpers'

export const listSms = (teamId, params) => {
  return api.get(`/sm/team/${teamId}/sms/report`, { params })
}

export const getSmsUsageStats = (teamId) => {
  return api.get(`/sm/team/${teamId}/sms/report/usage-stats`)
}
